import {
  IHeaderTextPageElement,
  ISubHeaderTextPageElement,
  IBodyTextPageElement,
  IPageDividerElementConfig,
  IPageDividerPageElement,
  IImageElementConfig,
  IImagePageElement,
  ITextElementConfig,
  ITextColumnsElement,
  ITextColumnsElementConfig,
  PortalPageElementType,
  ITextButtonElement,
  ITextButtonElementConfig,
  ISystemButtonPageElement,
  ISystemButtonElementConfig,
  ICustomHtmlPageElement,
  ICustomHtmlElementConfig,
} from './portal-page-elements';
import BasePortalPageElementsRestApi, {
  IPortalPageElementsApi,
} from './portal-page-elements/BasePortalPageElementsApi';

export type ITextPageElement =
  | IHeaderTextPageElement
  | ISubHeaderTextPageElement
  | IBodyTextPageElement;

export type IPortalLandingPageElement =
  | ITextPageElement
  | IPageDividerPageElement
  | IImagePageElement
  | ITextColumnsElement
  | ITextButtonElement
  | ICustomHtmlPageElement
  | ISystemButtonPageElement;

export type IPortalLandingPageElementConfig =
  | ITextElementConfig
  | IPageDividerElementConfig
  | IImageElementConfig
  | ITextColumnsElementConfig
  | ITextButtonElementConfig
  | ICustomHtmlElementConfig
  | ISystemButtonElementConfig;

export default class PortalLandingPageElementsRestApi
  extends BasePortalPageElementsRestApi<PortalPageElementType, IPortalLandingPageElement>
  implements IPortalPageElementsApi<IPortalLandingPageElement> {
  protected resourceName = 'portal-landing-page-elements';
}
